module.exports = __webpack_public_path__ + "assets/img/loginBg.9acc93fe.png";